;(function () {
  var MOBILE_BREAKPOINT = 750;

  function initSanCommunityGrid() {
    var sections = document.querySelectorAll('.san-community-grid-section');
    
    if (sections.length === 0) return;
    
    sections.forEach(function (section) {
      var wrapper = section.querySelector('.san-community-grid');
      if (!wrapper) return;
      
      var layoutMode = wrapper.getAttribute('data-layout-mode') || 'grid';
      var blockCount = parseInt(wrapper.getAttribute('data-block-count'), 10) || 0;
      var swiperEl = section.querySelector('.san-community-grid__swiper');
      
      if (blockCount < 1 || !swiperEl) return;
      
      var swiperInstance = null;
      
      function shouldUseSlider() {
        // Always use slider on mobile
        if (window.innerWidth < MOBILE_BREAKPOINT) {
          return true;
        }
        // On desktop, use slider only if layout mode is 'slider'
        return layoutMode === 'slider';
      }
      
      function initSwiper() {
        if (swiperInstance) return; // Already initialized
        
        swiperInstance = new Swiper(swiperEl, {
          // Layout
          slidesPerView: 1.2,
          spaceBetween: 48,
          centeredSlides: false,
          
          // Behavior
          loop: blockCount >= 3,
          grabCursor: true,
          watchSlidesProgress: true,
          
          // Autoplay
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          
          // Speed
          speed: 600,
          
          // Responsive breakpoints
          breakpoints: {
            450: {
              slidesPerView: 1.4,
              spaceBetween: 56,
            },
            550: {
              slidesPerView: 1.6,
              spaceBetween: 64,
            },
            750: {
              slidesPerView: 2.5,
              spaceBetween: 64,
            },
            990: {
              slidesPerView: 3.5,
              spaceBetween: 64,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 64,
            },
          },
        });
        
        wrapper.classList.add('swiper-initialized');
      }
      
      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
          wrapper.classList.remove('swiper-initialized');
        }
      }
      
      function handleResize() {
        var needsSlider = shouldUseSlider();
        
        if (needsSlider && !swiperInstance) {
          initSwiper();
        } else if (!needsSlider && swiperInstance) {
          destroySwiper();
        }
      }
      
      // Initial setup
      if (shouldUseSlider()) {
        initSwiper();
      }
      
      // Handle resize with debounce
      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
      });
    });
  }

  // Wait for Swiper to be available
  function waitForSwiper(callback, maxAttempts) {
    var attempts = 0;
    maxAttempts = maxAttempts || 50;
    
    function check() {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 100);
      } else {
        console.warn('SAN Community Grid: Swiper not loaded after max attempts');
      }
    }
    check();
  }

  // Initialize when DOM is ready and Swiper is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(initSanCommunityGrid);
    });
  } else {
    waitForSwiper(initSanCommunityGrid);
  }

  // Reinitialize on Shopify Theme Editor events
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('san-community-grid-section')) {
      waitForSwiper(initSanCommunityGrid);
    }
  });
})();